module.exports = __webpack_public_path__ + "static/img/ad_logo.5331d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tabbar-icon/ad_logo.png
// module id = uNer
// module chunks = 65